import { WizardContentHeaderKicker } from '@/components/Wizard'
import measureOneLogoUrl from '@/assets/misc/measureone-logo.png'
import styles from './MeasureOneKicker.module.css'

export function MeasureOneKicker() {
  return (
    <WizardContentHeaderKicker>
      <span className={styles.kicker}>
        Connecting with
        <img className={styles.logo} src={measureOneLogoUrl} alt="MeasureOne" />
        <strong>Measure</strong>One
      </span>
    </WizardContentHeaderKicker>
  )
}
